import styled from "@emotion/styled";


export const AddressNotMatchedMessageCardWrapper = styled.div<{ theme: Theme }>`
    margin-bottom: ${({ theme }) => theme.messageCardBorderBottom};
`;
